import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { webCampaign } from '@/modules/webCampaign';
import { preloadImage } from '@/utils/preloadImage';

export const useDominatePaywallPreload = () => {
  React.useEffect(() => {
    const notes = webCampaign.getLayoutNotes();
    const isLucy = notes?.includes('lucy');
    const basePath = isLucy ? 'lucy-v2' : 'jia';

    // Preload main paywall image based on selected persona
    preloadImage(
      `${S3_BUCKET_URL}/paywall/v5-dominate/${basePath}/paywall.png`,
    );

    // Preload success page images based on selected persona
    preloadImage(
      `${S3_BUCKET_URL}/success-page/default/dominate/${basePath}/congrats.png`,
    );
    preloadImage(`${S3_BUCKET_URL}/success-page/default/dominate/main.png`);
    preloadImage(`${S3_BUCKET_URL}/success-page/default/dominate/overlay.png`);
  }, []);
};
